export { default } from "./InteractivePollOption";
